module.exports = __webpack_public_path__ + "img/quizz-step-4-3.26fb2bfb.jpg";